/** @jsxImportSource @emotion/react */
import { useTranslation } from 'next-i18next'
import { Box, Button, Spinner, Text } from 'grommet'
import { CaretDownFill, CaretUpFill } from 'grommet-icons'

import { colors } from 'theme'
import useDeviceSize from 'hooks/useDevice'

const boxShadow = `0px 0px 8px -2px ${colors['accent-1']}`

type Props = {
  onClick: () => void
  onToggle: () => void
  open: boolean
  fetching: boolean
  disabled: boolean
}
export default function SplitMoodButton({ onClick, onToggle, open, disabled, fetching }: Props) {
  const { t } = useTranslation()
  const { small } = useDeviceSize()

  return (
    <Box direction="row" gap="2px">
      <Box fill="horizontal">
        <Button
          primary
          fill="vertical"
          color="accent-1"
          disabled={disabled}
          onClick={onClick}
          size={small ? 'large' : 'small'}
          css={{
            borderRadius: '.25rem 0 0 .25rem', // only left
            '&:hover': { boxShadow },
          }}
          icon={fetching ? <Spinner /> : undefined}
          label={
            <Text color="white" size={small ? 'large' : 'small'}>
              {t('cta.add-mood')}
            </Text>
          }
        />
      </Box>
      <Button
        primary
        fill="vertical"
        color="accent-1"
        disabled={disabled}
        css={{
          padding: small ? undefined : '.4rem',
          borderRadius: '0 .25rem .25rem 0', // only right
          '&:hover': { boxShadow },
        }}
        onClick={onToggle}
        icon={open ? <CaretUpFill color="white" /> : <CaretDownFill color="white" />}
      />
    </Box>
  )
}
